import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  postBulkScheduleMessageFailure,
  postBulkScheduleMessageSuccess,
} from "../slices/features/postScheduleMessage";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* postBulkScheduleMessageSaga(action: any) {
  const { payload } = action;
  const { id, data } = payload;
  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      appservice.postBulkScheduleMessage,
      baseUrl,
      id,
      data
    );

    yield put(postBulkScheduleMessageSuccess({ ...response }));
    payload?.cbSuccess && payload?.cbSuccess();
  } catch (error: any) {
    const { statusCode, statusText } = error;
    const message = error?.data?.errors?.message;

    payload?.cbFailure && payload?.cbFailure(message);

    yield put(postBulkScheduleMessageFailure({ statusCode, statusText }));
  }
}

export function* watchPostBulkScheduleMessage() {
  yield takeLatest(
    RequestTypes.POST_BULK_SCHEDULE_MSG_REQUEST,
    postBulkScheduleMessageSaga
  );
}
